<template>
    <v-container>
        <v-row v-if="selectedItems.length > 0"
               class="d-flex align-center rounded-lg"
               :style="{background: elementBackgroundColor}">
            <v-col cols="6" class="start">
                <span :style="{ color: elementTextColor }" class="element">
                    {{ selectedItems.length }} item(s) selected
                </span>
            </v-col>
            <v-col cols="6" class="end delete">
                <v-btn @click="deleteSelection(selectedItems)"
                       prepend-icon="mdi-delete"
                       variant="outlined"
                       :style="{ color: elementTextColor }"
                       class="delete">DELETE</v-btn>
            </v-col>
        </v-row>
        <v-row justify="start">
            <v-col>
                <v-data-table :headers="headers"
                              :items="loglist"
                              v-model:sort-by="sortBy"
                              :items-per-page="15"
                              :items-per-page-options="[
						{ value: 15, title: '15' },
						{ value: 30, title: '30' },
						{ value: 50, title: '50' },
						{ value: 100, title: '100' },
						{ value: 200, title: '200' },
					]"
                              loading-text="Loading... Please wait"
                              :multi-sort="true"
                              :hover="true"
                              :show-select="shouldShowSelect"
                              v-model="selectedItems">
                    <template v-slot:top>
                        <v-card class="d-flex align-center pa-1 pb-2">
                            <span class="blue--text font-weight-medium">Log</span>
                            <v-spacer></v-spacer>
                        </v-card>
                    </template>
                    <template v-slot:[`item.message`]="{ item }">
                        <v-textarea class="ma-0 pa-0 logMonospace w-auto h-auto"
                                    readonly
                                    full-width
                                    auto-grow
                                    no-resize
                                    v-model="item.message" />
                    </template>

                    <template v-slot:[`item.action`]="{ item }">
                        <v-icon small @click="deleteLog(item)">mdi-delete</v-icon>
                    </template>
                    <template v-slot:no-data>
                        <span>No Data Available</span>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<style>
    .logMonospace {
        font-family: monospace;
        font-size: 20px;
    }
</style>

<script>
    import { mapState, mapActions } from "vuex";
    import { REMOVE_LOG, LOAD_LOGS, REMOVE_LOGS } from "@/store/_actiontypes";

    export default {
        data: () => ({
            loading: false,
            dialog: false,
            menu: false,
            timer: undefined,
            selectedItems: [],
            sortBy: [{ key: 'createdAt', order: 'asc' }],

            headers: [
                { title: "Id", key: "id", width: 50 },
                { title: "Name", key: "hostName", sortable: false, width: 50},
                { title: "Direction", key: "direction", sortable: false, width: 120 },
                { title: "TimeStamp", key: "createdAt", width: 170 },
                { title: "Message", key: "message", sortable: false },
                { title: "Actions", key: "action", sortable: false, width: 50 },
            ],
            editedLog: {
                id: 0,
                hostName: "",
                direction: "",
                createdAt: "",
                message: 0,
            },
            defaultLog: {
                id: 0,
                hostName: "",
                direction: "",
                createdAt: "",
                message: 0,
            },
        }),

        computed: {
            ...mapState({ loglist: (state) => state.logs.loglist }),
            hostFormTitle() {
                return "View Log";
            },
            shouldShowSelect() {
                return this.loglist.length >= 1;
            },

            elementTextColor() {
                return this.$vuetify.theme.global.name === "dark" ? "white" : "black";
            },
            elementBackgroundColor() {
                return this.$vuetify.theme.global.name === "dark" ? "#3d1924" : "#cfe4f2";
            },
        },
        async created() {
            await this.loadData();
            this.timer = setInterval(this.loadData, 10000);
        },
        watch: {
            dialog(val) {
                val || this.close();
            },
            selectedItems(val) {
                this.selectedItems = val;
            },
        },

        methods: {
            ...mapActions("logs", [REMOVE_LOG, REMOVE_LOGS]),
            async loadData() {
                this.loading = true;
                this.$store.dispatch(`logs/${LOAD_LOGS}`);
                this.loading = false;
            },

            getSortBy() {
                return [this.sortByField];
            },

            deleteLog(item) {
                confirm("Are you sure you want to delete this item?") &&
                    this.REMOVE_LOG({ id: item.id });
            },
            deleteSelection() {
                const ids = [];
                for (var val in this.selectedItems) {
                    ids.push(this.selectedItems[val]);
                }
                if (
                    confirm(
                        `Are you sure you want to delete ${ids.length} selected item(s)?`
                    )
                ) {
                    this.REMOVE_LOGS({ ids: ids }).then(() => {
                        this.loading = false;
                    });
                    this.selectedItems = [];
                }
            },
            close() {
                this.dialog = false;
            },
        },
        beforeUnmount() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = undefined;
            }
        },
    };
</script>

<style>
    .element {
        padding: 10px;
        border: none;
        color: black;
    }

    .start {
        display: flex;
        justify-content: flex-start;
    }

    .end {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .delete {
        cursor: pointer;
    }
</style>
